import { Pipe, PipeTransform } from '@angular/core';
import { convertEnumToOptions } from '../../common/decorators/description.decorator';

@Pipe({
  name: 'multiOptionsMapping',
  pure: false,
})
export class MultiOptionsMappingPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value && typeof value === 'string') {
      value = value.split(',');
    }
    if (Array.isArray(args[0])) {
      return this.convertToLabel(args[0], value) ?? value?.join(', ');
    }
    const options = convertEnumToOptions(args[0]);
    return this.convertToLabel(options, value) ?? value?.join(', ');
  }

  convertToLabel = (selectOptions: any[], valueArray: any[]): string => {
    let labelStr = '' as string;
    let labelArray = [] as any[];

    if (valueArray && valueArray.length > 0) {
      valueArray.forEach((value: any) => {
        const option = selectOptions.find((x) => x.value === value);
        labelArray.push(option?.label ?? value);
      });
      labelStr = labelArray.join(', ');
    }
    return labelStr;
  };
}
